<template>
    <modal name="listEntitasDetail" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog  modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> Detail Entitas </h5>
                        <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <vue-good-table title="list-entitas" :rows="rowsEntitas" :columns="columns" 
                            :line-numbers="true" :isLoading="isLoading">
                            <div slot="emptystate">
                                Empty Row
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'npwpNama'">
                                    {{ props.row.nomorIdentitas + " - " + props.row.namaEntitas }}
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">Batal</button>
                    </div>

                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "modalListEntitas",
    props: {
        idDocument: Number
    },
    data() {
        return {
            lastId:null,
            isLoading: false,
            rowsEntitas: [],
            columns: [
                {
                    label: "Jenis Entitas", 
                    field: 'namaKodeEntitas',
                    type: 'text',
                    thClass: 'text-center',
                },
                {
                    label: "NPWP & Nama",
                    field: 'npwpNama',
                    type: 'text',
                    thClass: 'text-center',
                },
                {
                    label: "Alamat",
                    field: 'alamatEntitas',
                    type: 'text',
                    thClass: 'text-center',
                },
                {
                    label: "Negara",
                    field: 'namaNegara',
                    type: 'text',
                    thClass: 'text-center',
                },
            ],

        }
    },
    methods: {
        removeModals() {
            this.$emit("closeModal");
        },
        loadDetail(id) {

            const baseURI = this.$settings.endPointCeisa + "v1/document/detail/" + id;

            return this.$http.get(baseURI, { timeout: 100000 }).then((response) => {
                this.rowsEntitas = response.data.datas.entitas;
                this.isLoading = false;
            }).catch(error => {

                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }

            });

        }
    },
    watch: {
        idDocument: function (newVal) {
            if (newVal) {
                if(this.lastId !== newVal ){
                    this.isLoading = true;
                    this.rowsEntitas = [];
                    this.lastId = newVal;
                    this.loadDetail(newVal);
                }
            }
        },
    }
}
</script>

<style></style>